import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

const MCEadContentCard = (props) => {

    return (
        <div className={'mc-ead-content-card ' + props.classNames  } style={props.style}>

            {props.children}


        </div>
    )
}

MCEadContentCard.propTypes = {
    classNames: PropTypes.string,
}

MCEadContentCard.defaultProps = {
    classNames: ''
}

export default MCEadContentCard



// WEBPACK FOOTER //
// ./src/components/_ead/ContentCard/index.js